"use strict";

module.exports = curry3;
function curry3(f) {
  return function curried(a, b, c) {
    if (arguments.length >= 3) return f(a, b, c);
    if (arguments.length === 2) return function (c2) {
      return f(a, b, c2);
    };
    return function (b2, c2) {
      if (arguments.length === 2) return f(a, b2, c2);
      return function (c3) {
        return f(a, b2, c3);
      };
    };
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/nanoutils/cjs/_internal/_curry3/index.js
// module id = 522
// module chunks = 0